
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SocialLinks from "@/components/common/SocialLinks";

const Index = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-league-background dark:bg-league-background">
      <header className="bg-gradient-to-b from-league-secondary to-league-background border-b border-league-muted/30 py-3 md:py-4">
        <div className="container px-3 md:px-4 mx-auto flex justify-between items-center">
          <div className="flex items-center">
            <img 
              src="/striveleague-uploads/a0055435-152e-4efa-8135-aae028cbd56d.png" 
              alt="Strive League Logo" 
              className="h-8 md:h-10 w-auto mr-2 md:mr-3" 
            />
          </div>
          <div className="flex items-center space-x-2 md:space-x-4">
            <Button variant="ghost" size="sm" onClick={() => navigate("/login")} className="text-sm">
              Login
            </Button>
            <Button variant="default" size="sm" onClick={() => navigate("/register")} className="text-sm">
              Register
            </Button>
          </div>
        </div>
      </header>
      
      <main>
        <section className="py-12 md:py-20 px-3 md:px-4 bg-gradient-to-b from-league-background to-league-secondary/90 text-center">
          <div className="container mx-auto max-w-5xl">
            <h1 className="text-3xl md:text-4xl lg:text-6xl font-bold mb-4 md:mb-6">
               {t('home.welcome')}
            </h1>
            <p className="text-base md:text-lg lg:text-xl mb-6 md:mb-8 text-muted-foreground max-w-3xl mx-auto px-4">
              {t('home.subtitle')}
            </p>
            <div className="flex flex-col sm:flex-row md:flex-row justify-center gap-3 md:gap-4 px-4">
              <Button size="lg" onClick={() => navigate("/register")} className="w-full sm:w-auto">
                {t('home.joinNow')}
              </Button>
              <Button size="lg" variant="outline" onClick={() => navigate("/leagues")} className="w-full sm:w-auto">
                {t('home.exploreLeagues')}
              </Button>
            </div>
          </div>
        </section>
        
        <section className="py-12 md:py-16 px-3 md:px-4 bg-league-secondary/80">
          <div className="container mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 md:mb-10">{t('home.features.title')}</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              <div className="bg-league-background/80 p-4 md:p-6 rounded-lg border border-league-muted/30 hover:border-primary/40 transition-colors">
                <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-accent">{t('home.features.teamManagement.title')}</h3>
                <p className="text-muted-foreground text-sm md:text-base">{t('home.features.teamManagement.description')}</p>
              </div>
              <div className="bg-league-background/80 p-4 md:p-6 rounded-lg border border-league-muted/30 hover:border-primary/40 transition-colors">
                <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-accent">{t('home.features.competitiveLeagues.title')}</h3>
                <p className="text-muted-foreground text-sm md:text-base">{t('home.features.competitiveLeagues.description')}</p>
              </div>
              <div className="bg-league-background/80 p-4 md:p-6 rounded-lg border border-league-muted/30 hover:border-primary/40 transition-colors">
                <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-accent">{t('home.features.matchReporting.title')}</h3>
                <p className="text-muted-foreground text-sm md:text-base">{t('home.features.matchReporting.description')}</p>
              </div>
            </div>
          </div>
        </section>
        
        <section className="py-12 md:py-16 px-3 md:px-4 bg-gradient-to-b from-league-secondary/90 to-league-background text-center">
          <div className="container mx-auto max-w-3xl">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6">{t('home.readyToCompete.title')}</h2>
            <p className="text-base md:text-lg mb-6 md:mb-8 text-muted-foreground px-4">
              {t('home.readyToCompete.subtitle')}
            </p>
            <Button size="lg" onClick={() => navigate("/register")} className="w-full sm:w-auto">
              {t('home.readyToCompete.createAccount')}
            </Button>
          </div>
        </section>
      </main>
      
      <footer className="bg-league-background py-4 md:py-6 border-t border-league-muted/30">
        <div className="container mx-auto px-3 md:px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6">
            <p className="text-muted-foreground text-xs md:text-sm order-3 md:order-1 text-center">
              &copy; {new Date().getFullYear()} Strive League. {t('footer.rights')}
            </p>
            <div className="flex flex-wrap justify-center space-x-4 md:space-x-6 order-2 text-xs md:text-sm">
              <a href="/contact" className="text-muted-foreground hover:text-primary">{t('footer.about')}</a>
              <a href="/rules" className="text-muted-foreground hover:text-primary">{t('footer.rules')}</a>
              <a href="/contact" className="text-muted-foreground hover:text-primary">{t('footer.contact')}</a>
              <a href="/contact" className="text-muted-foreground hover:text-primary">{t('footer.privacy')}</a>
            </div>
            <div className="order-1 md:order-3">
              <SocialLinks />
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;
